import { useOrders } from "@/features/orders/hooks/useOrders";
import { useMyActiveTrips } from "@/features/trips";
import { ActiveTripPanel } from "./ActiveTripPanel";
import { RecentOrdersPanel } from "./RecentOrdersPanel";
import { SupportPanel } from "./SupportPanel";

/**
 * Colonne contextuelle du client (≥ xl) — rendue par `AppShell` sur TOUTES les
 * pages de l'espace client, pas seulement l'accueil.
 *
 * ## Autonome en données, volontairement
 * Le composant va chercher lui-même la course active et l'historique plutôt que
 * de les recevoir en props. `AppShell` est un composant de mise en page : lui
 * faire porter des requêtes métier l'obligerait à connaître le domaine client,
 * et chaque écran devrait les lui repasser. TanStack Query dédoublonne par clé,
 * donc l'accueil — qui interroge les mêmes hooks pour son propre flux — ne
 * déclenche pas d'appel supplémentaire.
 *
 * ## Les trois sections sont permanentes
 * Chacune porte son état vide. Une colonne dont les blocs apparaissent et
 * disparaissent au fil des courses change de forme sous les yeux du client et
 * déplace ce qu'il s'apprêtait à cliquer ; à structure fixe, il apprend une
 * fois où regarder.
 */
export function ClientAside() {
  const activeTripsQuery = useMyActiveTrips();
  const recentOrdersQuery = useOrders("done");

  return (
    <div className="flex flex-col gap-6 p-5">
      <ActiveTripPanel trip={activeTripsQuery.data?.[0]} />
      <RecentOrdersPanel orders={(recentOrdersQuery.data ?? []).slice(0, 3)} />
      <SupportPanel />
    </div>
  );
}
